
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({})
export default class AppComponent extends Vue {
  async created(): Promise<void> {
    await this.$store.dispatch("AuthStore/handleRedirectCallback");
  }
}
